import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
  ${props => props.containerStyle}
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
  font-weight: 500;
`;

const InputField = styled.input`
  width: ${props => props.width || '90%'};
  padding: 10px 12px;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.3s;

  &:focus {
    border-color: #007AFF;
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.25);
  }

  &::placeholder {
    color: #aaa;
  }
`;

const ErrorText = styled.span`
  color: #ff3b30;
  font-size: 12px;
  position: absolute;
  bottom: -20px;
  left: 0;
`;

const MyTextInput = React.forwardRef(({ label, error, containerStyle, width, ...props }, ref) => {
  return (
    <InputWrapper containerStyle={containerStyle}>
      {label && <Label>{label}</Label>}
      <InputField width={width} {...props} ref={ref} aria-invalid={!!error} />
      {error && <ErrorText>{error}</ErrorText>}
    </InputWrapper>
  );
});

export default MyTextInput;